export const surveysSelector = state => state.surveys;
